import React from "react"
import { Image } from "terra-one"

const ImageComponent = ({ contentfulId, source, alt }) => {
  return source ? (
    <Image
      contentfulId={contentfulId}
      className="imageSection"
      src={source}
      alt={alt}
    />
  ) : null
}

export default ImageComponent
